import { Mutation } from './mutations'

export const resolvers = {
  Mutation
}